<template>
   <div class="card modal-card is-min-width-800">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('ajoutEditContrat.echeancier.popupAnnulationPaiement.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="modal-card-body">
      <div class="card-content">
        <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'remiseBancaire.errors.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
        <div class="columns mgt-20px">
          <div class="column is-4">
            <p class="has-text-default">
              {{$t('ajoutEditContrat.echeancier.popupAnnulationPaiement.columns.bailleur') }}
            </p>
            <span class="has-text-weight-bold">
              {{ echeance.tiers.nomCommercial}}
            </span>
          </div>
          <div class="column is-2">
            <p class="has-text-default">
              {{$t('ajoutEditContrat.echeancier.popupAnnulationPaiement.columns.debutPeriode') }}
            </p>
            <span class="has-text-weight-bold">
              {{ echeance.debutPeriode | formatDate }}
            </span>
          </div>
          <div class="column is-2">
            <p class="has-text-default">
              {{$t('ajoutEditContrat.echeancier.popupAnnulationPaiement.columns.finPeriode') }}
            </p>
            <span class="has-text-weight-bold">
              {{ echeance.finPeriode | formatDate }}
            </span>
          </div>
          <div class="column is-4">
            <p class="has-text-default">
              {{$t('ajoutEditContrat.echeancier.popupAnnulationPaiement.columns.montantTtc') }}
            </p>
            <span class="has-text-weight-bold">
              {{ echeance.montantTtc | formatDevise }}
            </span>
          </div>
        </div>
        <b-table :data="paiements" :bordered="true" :striped="true">
          <b-table-column field="selected"
            v-slot="props">
            <qd-checkbox v-if="props.row.selected !== undefined"
                    v-model="props.row.selected">
            </qd-checkbox>
          </b-table-column>
          <b-table-column field="modePaiement"
            v-slot="props"
            :label="$t('ajoutEditContrat.echeancier.popupAnnulationPaiement.columns.modePaiement')">
            <span v-if="props.row.modeReglement">{{ props.row.modeReglement.libelle }}</span>
          </b-table-column>
          <b-table-column field="numeroPaiement"
            v-slot="props"
          :label="$t('ajoutEditContrat.echeancier.popupAnnulationPaiement.columns.numeroPaiement')">
            <span v-if="props.row.ligneRemiseBancairePseudoEntity ">
              {{ props.row.ligneRemiseBancairePseudoEntity.referenceReglement }}
            </span>
          </b-table-column>
          <b-table-column field="dateEcheance"
            v-slot="props"
            :label="$t('ajoutEditContrat.echeancier.popupAnnulationPaiement.columns.dateEcheance')">
            <span>{{props.row.dateMouvement  | formatDate }}</span>
          </b-table-column>
          <b-table-column field="montant"
            v-slot="props"
            :label="$t('ajoutEditContrat.echeancier.popupAnnulationPaiement.columns.debit')"
            cell-class="right">
            <span>{{props.row.debit - props.row.credit | formatDevise}}</span>
          </b-table-column>
          <b-table-column field="remise"
            v-slot="props"
            :label="$t('ajoutEditContrat.echeancier.popupAnnulationPaiement.columns.remise')">
            <span v-if="props.row.remiseBancaire">
              {{ props.row.remiseBancaire.nom }} ({{ props.row.remiseBancaire.num }})
            </span>
          </b-table-column>
        </b-table>

        <footer class="mgt-20px">
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="cancelPayment()">
              {{$t('ajoutEditContrat.echeancier.popupAnnulationPaiement.actions.annulerPaiements')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { getAllPaiements } from '@/api/commandeAchat/index';
import { annulerPaiementsAsync } from '@/api/mouvementClient/index';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import validation from '@/services/validation/validation';
import validationAnnulationPaiement from '@/services/baux/echeancierContrat/validationAnnulationPaiement';

export default {
  props: {
    echeance: {
      type: Object,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      paiements: [],
    };
  },
  methods: {
    async cancelPayment() {
      this.error = false;
      this.messagesChampsVide = [];
      const ids = [];
      this.paiements.forEach(pmt => {
        if (pmt.selected === true) ids.push(pmt.id);
      });
      if (ids.length === 0) {
        this.error = true;
        this.messagesChampsVide.push(this.$i18n
          .t('ajoutEditContrat.echeancier.popupAnnulationPaiement.errors.emptySelection'));
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        await annulerPaiementsAsync(ids);
        loadingComponent.close();
        messageSuccess(this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.message.successPayer'));
        this.$emit('refresh');
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, null);
          validationAnnulationPaiement(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const response = await getAllPaiements(this.echeance.devisCommandeId);
      if (response !== undefined && response !== null && response.data !== undefined
        && response.data !== null && response.data.result !== undefined) {
        this.paiements = response.data.result;
        this.paiements.forEach(pmt => {
          pmt.selected = true;
        });
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style>

</style>
